import { useEffect, useState } from "react";
import { Link } from "@tanstack/react-router";
import { ArrowRight, BookOpen } from "lucide-react";
import { browserLocale } from "@/lib/locale";

const HINDI_POSTS = [
  {
    slug: "aaghat-se-ubharna-pehla-kadam",
    title: "आघात से उबरना: पहला कदम कैसा दिखता है",
    excerpt: "उबरना सीधी रेखा नहीं है — शुरुआत कैसी दिखती है और क्या मदद करता है।",
  },
  {
    slug: "zameen-se-judne-ke-abhyas",
    title: "ज़मीन से जुड़ने के अभ्यास",
    excerpt: "सरल अभ्यास जिन्हें आप कहीं भी कर सकते हैं, ताकि शरीर वर्तमान पल में लौट सके।",
  },
  {
    slug: "nervous-system-ko-shant-karna",
    title: "नर्वस सिस्टम को शांत करना",
    excerpt: "शरीर सोचने से पहले क्यों प्रतिक्रिया करता है, और धीरे-धीरे क्या मदद करता है।",
  },
] as const;

/**
 * Articles written in Hindi, shown only to readers on the Hindi pages.
 * The language is read in the browser, so the section never appears in the
 * English, German, French, Spanish, Chinese or Arabic versions of the page.
 */
export function HindiReadingSection() {
  const [isHindi, setIsHindi] = useState(false);
  useEffect(() => setIsHindi(browserLocale() === "hi"), []);
  if (!isHindi) return null;

  return (
    <section
      data-no-translate
      dir="ltr"
      className="rounded-2xl border border-gold/25 bg-gold-light/15 p-5 sm:p-6"
    >
      <h2 className="flex items-center gap-2 font-display text-xl text-foreground sm:text-2xl">
        <BookOpen className="h-5 w-5 text-[var(--gold-deep)]" />
        हिंदी में पढ़ें
      </h2>
      <p className="mt-1.5 text-sm leading-relaxed text-foreground/75">
        आघात से उबरने, ज़मीन से जुड़ने के अभ्यास और नर्वस सिस्टम को शांत करने पर सरल हिंदी में
        लेख।
      </p>

      <ul className="mt-4 grid gap-3 sm:grid-cols-3">
        {HINDI_POSTS.map((post) => (
          <li key={post.slug}>
            <Link
              to="/blog/$slug"
              params={{ slug: post.slug }}
              className="group flex h-full flex-col rounded-xl border border-border bg-card p-4 transition-colors hover:border-gold/40"
            >
              <span className="font-medium leading-snug text-foreground">{post.title}</span>
              <span className="mt-1.5 text-sm leading-relaxed text-muted-foreground">
                {post.excerpt}
              </span>
              <span className="mt-3 inline-flex items-center gap-1 text-sm font-medium text-[var(--gold-deep)]">
                पढ़ें
                <ArrowRight className="h-3.5 w-3.5 transition-transform group-hover:translate-x-0.5" />
              </span>
            </Link>
          </li>
        ))}
      </ul>

      <Link
        to="/blog"
        className="mt-4 inline-flex items-center gap-1 text-sm font-medium text-[var(--gold-deep)]"
      >
        सभी लेख देखें
        <ArrowRight className="h-3.5 w-3.5" />
      </Link>
    </section>
  );
}
